import PageViewTable from '@/features/payments/components/PageViewTable/PageViewTable'
import { useAdminPageViews } from '@/features/admins/page_views/hooks/useAdminPageViewsApi'

function AdminPageViewTable() {
    const queryResult = useAdminPageViews();

    return <PageViewTable queryResult={queryResult} />;
}

export default AdminPageViewTable;
